import { render, staticRenderFns } from "./DocFaceLibraryNew.vue?vue&type=template&id=18705e65&scoped=true"
import script from "./DocFaceLibraryNew.vue?vue&type=script&lang=js"
export * from "./DocFaceLibraryNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18705e65",
  null
  
)

export default component.exports